import React from 'react';

interface PathDisplayProps {
    isVisible: boolean;
    debouncedHoveredPath: string;
    viewerWidth: number;
    maximizedPosition: 'left' | 'right';
}

/**
 * Component to display the current path being hovered
 * @param props - Component props
 * @returns Rendered component or null if not visible
 */
const PathDisplay: React.FC<PathDisplayProps> = ({
    isVisible,
    debouncedHoveredPath,
    viewerWidth,
    maximizedPosition,
}) => {
    if (!isVisible) return null;

    return (
        <div
            className="fixed z-[100001] truncate border-t border-gray-300 bg-gray-100 p-2 font-mono text-xs"
            style={{
                bottom: '0',
                width: `${viewerWidth}vw`,
                minWidth: '400px',
                [maximizedPosition === 'right' ? 'right' : 'left']: '0',
            }}
        >
            <span className="font-semibold">Path: </span>
            <span className="text-link">{debouncedHoveredPath}</span>
        </div>
    );
};

export default PathDisplay;
